export default __webpack_public_path__ + "static/media/H4007.2.ed46da08.mp3";